import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const voucherSlice = createSlice({
  name: "voucher",
  initialState: {
    vouchers: [],
    voucherDetails: {},
    refetch: false,
  },
  reducers: {
    setVouchers: (state, action) => {
      state.vouchers = action.payload;
    },
    setVoucherDetails: (state, action) => {
      state.voucherDetails = action.payload;
    },
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
  },
});

export const { setVouchers, setVoucherDetails, refetch } = voucherSlice.actions;

export const createVoucher = (formData, setLoading) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/voucher/create/v1`;
    const { data } = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Voucher created successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const updateVoucher = (id, formData, setLoading,navigate) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/voucher/update/${id}/v1`;
    const { data } = await axios.put(url, formData, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Voucher updated successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    dispatch(refetch(true));
    navigate(-1)
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const getVouchers = (setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/voucher/admin/get/list/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });

    dispatch(setVouchers(data.data));
    setLoading(false);
  } catch (error) {
    console.log(error, "error");
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const getVoucherDetails = (id, setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/voucher/admin/get/details/${id}/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setVoucherDetails(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const removeVoucher = (id, setLoading, setDeleteModal) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/voucher/delete/${id}/v1`;
    const { data } = await axios.delete(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Voucher deleted successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
    setDeleteModal(false);
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
    setDeleteModal(false);
  }
};

export const changeStatus = (id, setLoading) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/voucher/change/status/${id}/v1`;
    const { data } = await axios.put(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Voucher status changed successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export default voucherSlice.reducer;
